/// <amd-module name="Artifacts/Cargo/RestClient/CargoApi" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   packaging\client\cargo\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as CargoApi from "Artifacts/Cargo/Contracts/CargoApi";
import * as PackagingShared from "Artifacts/Root/types/PackagingShared";

import { ICargoApiRestClient } from "Artifacts/Cargo/RestClient/CargoApi.Types";

export { ICargoApiRestClient } from "Artifacts/Cargo/RestClient/CargoApi.Types";

class CargoApiRestClient extends RestClientBase implements ICargoApiRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Update several packages from a single feed in a single request. The updates to the packages do not happen atomically.
     * 
     * @param batchRequest - Information about the packages to update, the operation to perform, and its associated data.
     * @param feedId - Name or ID of the feed.
     * @param project - Project ID or project name
     */
    public async updatePackageVersions(
        batchRequest: CargoApi.CargoPackagesBatchRequest,
        feedId: string,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_packaging/packaging/feeds/{feedId}/cargo/packagesBatch",
            routeValues: {
                project: project,
                feedId: feedId
            },
            body: batchRequest
        });
    }

    /**
     * Delete or restore several package versions from the recycle bin.
     * 
     * @param batchRequest - Information about the packages to update, the operation to perform, and its associated data. \<c\>Operation\</c\> must be \<c\>PermanentDelete\</c\> or \<c\>RestoreToFeed\</c\>
     * @param feedId - Feed which contains the packages to update.
     * @param project - Project ID or project name
     */
    public async updateRecycleBinPackageVersions(
        batchRequest: CargoApi.CargoPackagesBatchRequest,
        feedId: string,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/cargo/RecycleBin/packagesBatch",
            routeValues: {
                project: project,
                feedId: feedId
            },
            body: batchRequest
        });
    }

    /**
     * Delete a package version from the feed, moving it to the recycle bin.
     * 
     * @param feedId - Name or ID of the feed.
     * @param packageName - Name of the package.
     * @param packageVersion - Version of the package.
     * @param project - Project ID or project name
     */
    public async deletePackageVersionFromRecycleBin(
        feedId: string,
        packageName: string,
        packageVersion: string,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/cargo/RecycleBin/packages/{packageName}/versions/{packageVersion}",
            routeValues: {
                project: project,
                feedId: feedId,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
    }

    /**
     * Get information about a package version in the recycle bin.
     * 
     * @param feedId - Name or ID of the feed.
     * @param packageName - Name of the package.
     * @param packageVersion - Version of the package.
     * @param project - Project ID or project name
     */
    public async getPackageVersionMetadataFromRecycleBin(
        feedId: string,
        packageName: string,
        packageVersion: string,
        project?: string
        ): Promise<CargoApi.CargoPackageVersionDeletionState> {

        return this.beginRequest<CargoApi.CargoPackageVersionDeletionState>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/cargo/RecycleBin/packages/{packageName}/versions/{packageVersion}",
            routeValues: {
                project: project,
                feedId: feedId,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
    }

    /**
     * Restore a package version from the recycle bin to its associated feed.
     * 
     * @param packageVersionDetails - Set the 'Deleted' state to 'false' to restore the package to its feed.
     * @param feedId - Name or ID of the feed.
     * @param packageName - Name of the package.
     * @param packageVersion - Version of the package.
     * @param project - Project ID or project name
     */
    public async restorePackageVersionFromRecycleBin(
        packageVersionDetails: CargoApi.CargoRecycleBinPackageVersionDetails,
        feedId: string,
        packageName: string,
        packageVersion: string,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/cargo/RecycleBin/packages/{packageName}/versions/{packageVersion}",
            routeValues: {
                project: project,
                feedId: feedId,
                packageName: packageName,
                packageVersion: packageVersion
            },
            body: packageVersionDetails
        });
    }

    /**
     * Get the upstreaming behavior of a package within the context of a feed
     * 
     * @param feed - The name or id of the feed
     * @param packageName - The name of the package
     * @param project - Project ID or project name
     */
    public async getUpstreamingBehavior(
        feed: string,
        packageName: string,
        project?: string
        ): Promise<PackagingShared.UpstreamingBehavior> {

        return this.beginRequest<PackagingShared.UpstreamingBehavior>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/packaging/feeds/{feed}/cargo/packages/{packageName}/upstreaming",
            routeValues: {
                project: project,
                feed: feed,
                packageName: packageName
            }
        });
    }

    /**
     * Set the upstreaming behavior of a package within the context of a feed
     * 
     * @param feed - The name or id of the feed
     * @param packageName - The name of the package
     * @param behavior - The behavior to apply to the package within the scope of the feed
     * @param project - Project ID or project name
     */
    public async setUpstreamingBehavior(
        feed: string,
        packageName: string,
        behavior: PackagingShared.UpstreamingBehavior,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/packaging/feeds/{feed}/cargo/packages/{packageName}/upstreaming",
            routeValues: {
                project: project,
                feed: feed,
                packageName: packageName
            },
            body: behavior
        });
    }

    /**
     * Send a package version from the feed to its paired recycle bin.
     * 
     * @param feedId - Name or ID of the feed.
     * @param packageName - Name of the package to delete.
     * @param packageVersion - Version of the package to delete.
     * @param project - Project ID or project name
     */
    public async deletePackageVersion(
        feedId: string,
        packageName: string,
        packageVersion: string,
        project?: string
        ): Promise<CargoApi.Package> {

        return this.beginRequest<CargoApi.Package>({
            apiVersion: "7.1-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/cargo/packages/{packageName}/versions/{packageVersion}",
            routeValues: {
                project: project,
                feedId: feedId,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
    }

    /**
     * Get information about a package version.
     * 
     * @param feedId - Name or ID of the feed.
     * @param packageName - Name of the package.
     * @param packageVersion - Version of the package.
     * @param project - Project ID or project name
     * @param showDeleted - True to show information for deleted package versions.
     */
    public async getPackageVersion(
        feedId: string,
        packageName: string,
        packageVersion: string,
        project?: string,
        showDeleted?: boolean
        ): Promise<CargoApi.Package> {

        const queryValues: any = {
            showDeleted: showDeleted
        };

        return this.beginRequest<CargoApi.Package>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/cargo/packages/{packageName}/versions/{packageVersion}",
            routeValues: {
                project: project,
                feedId: feedId,
                packageName: packageName,
                packageVersion: packageVersion
            },
            queryParams: queryValues
        });
    }

    /**
     * Update state for a package version.
     * 
     * @param packageVersionDetails - Details to be updated.
     * @param feedId - Name or ID of the feed.
     * @param packageName - Name of the package.
     * @param packageVersion - Version of the package.
     * @param project - Project ID or project name
     */
    public async updatePackageVersion(
        packageVersionDetails: CargoApi.PackageVersionDetails,
        feedId: string,
        packageName: string,
        packageVersion: string,
        project?: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "7.1-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/packaging/feeds/{feedId}/cargo/packages/{packageName}/versions/{packageVersion}",
            routeValues: {
                project: project,
                feedId: feedId,
                packageName: packageName,
                packageVersion: packageVersion
            },
            body: packageVersionDetails
        });
    }

}

export const CargoApiClientName = "CargoApi-AzureArtifacts.ICargoApiRestClient";

export function getCargoApiClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ICargoApiRestClient {
    return pageContext.getRestClient<ICargoApiRestClient>(CargoApiClientName, options);
}

RestClients.add(CargoApiClientName, { 
    factory: CargoApiRestClient,
    options: {
        resourceAreaId: "71f96160-8701-4914-aed9-c44b89f20ccd",
        serviceInstanceType: "00000030-0000-8888-8000-000000000000"
    }
});
